import { bucketUrl, FIREBASE_CONFIG } from '@lib/config'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const app = initializeApp(FIREBASE_CONFIG)
const auth = getAuth(app)

async function signOut() {
  if (auth.currentUser?.email) {
    return await auth.signOut()
  }
  window.location.href = '/'
}

const storage = getStorage(app, bucketUrl)

/**
 * Gets the path for private user content
 */
function getPrivateUserPath(hash: string): string {
  return `/private/concierge/user/${hash}`
}

/**
 * Gets the path for public concierge content
 */
function getPublicConciergePath(hash: string): string {
  return `/public/concierge/user/${hash}`
}

export { auth, getPrivateUserPath, getPublicConciergePath, signOut, storage }
